export default __webpack_public_path__ + "static/media/github.20938e69.svg";